import * as React from "react";
import { UserMessage } from "./userMessageTypes";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dialog from "material-ui/Dialog";

type Props = {
  userMessage: UserMessage;
  onClose: Function;
  duplicateUserMessage?: any;
  onMessageDuplicationComplete: any;
};

type State = {
  duplicating: boolean;
};

class DuplicateModal extends React.Component<Props, State> {
  state = { duplicating: false };

  onDuplicate = (): void => {
    this.setState({ duplicating: true });
    this.props
      .duplicateUserMessage({
        variables: {
          id: this.props.userMessage.id
        }
      })
      .then((result) => {
        const newMessageId = result?.data?.duplicate_user_message?.id;
        if (newMessageId != null) {
          this.props.onMessageDuplicationComplete(newMessageId);
        } else {
          this.props.onClose();
        }

      })
      .catch(error => {
        alert(error);
      })
      .finally(() => this.setState({ duplicating: false }));
  };

  render() {
    return (
      <Dialog
        title="Duplicate User Message"
        modal={false}
        open={this.props.userMessage != null}
        actions={[
          <Button color="secondary" onClick={() => this.props.onClose()}>
            No
          </Button>,
          <Button
            disabled={this.state.duplicating}
            color="primary"
            onClick={this.onDuplicate}
          >
            {this.state.duplicating ? "Duplicating..." : "Yes"}
          </Button>
        ]}
        onRequestClose={this.props.onClose}
      />
    );
  }
}

const duplicateUserMessage = graphql<Props, any, any>(
  gql`
    mutation duplicateUserMessage($id: ID!) {
      duplicate_user_message(id: $id) {
        id
      }
    }
  `,
  { name: "duplicateUserMessage" }
);

export default compose(duplicateUserMessage)(DuplicateModal);
